import React from "react";

import type { ActivityAttachment, PublishManualStep } from "../types/reviewTypes";
import useAttachmentDownload from "../hooks/useAttachmentDownload";
import AttachmentsTab from "./AttachmentsTab";
import ManualStepsTab from "./ManualStepsTab";
import PanelTabs from "./PanelTabs";

interface ActivityPanelTabsProps {
  attachments?: ActivityAttachment[];
  manualSteps?: PublishManualStep[];
  children: React.ReactNode;
}

function ActivityPanelTabs({ attachments, manualSteps, children }: ActivityPanelTabsProps) {
  const normalizedAttachments = attachments ?? [];
  const normalizedManualSteps = manualSteps ?? [];
  const { downloadOne, openOne, downloadAll, isDownloadingAll, isAttachmentBusy } = useAttachmentDownload();

  const hasAttachments = normalizedAttachments.length > 0;
  const hasManualSteps = normalizedManualSteps.length > 0;

  if (!hasAttachments && !hasManualSteps) {
    return <>{children}</>;
  }

  return (
    <PanelTabs
      attachmentsCount={normalizedAttachments.length}
      reviewContent={children}
      attachmentsContent={
        <AttachmentsTab
          attachments={normalizedAttachments}
          isDownloadingAll={isDownloadingAll}
          isAttachmentBusy={isAttachmentBusy}
          onDownload={downloadOne}
          onOpen={openOne}
          onDownloadAll={downloadAll}
        />
      }
      manualStepsCount={normalizedManualSteps.length}
      manualStepsContent={hasManualSteps ? <ManualStepsTab steps={normalizedManualSteps} /> : undefined}
    />
  );
}

export default ActivityPanelTabs;
